/**
 * 開機 splash（public/index.html 的 #boot-splash）的移除。
 *
 * splash 存在的理由：一次 LIFF 進站會經過 2～3 次完整 document load
 * （LINE OAuth 往返、深連結轉場都是整頁重載），每一次 React 都要重新掛載，
 * 中間必然露出白畫面。靜態 splash 讓每次載入的第一個 frame 就是同一張圖，
 * 使用者看到的才會是「一次連續的載入」而不是「跳了好幾頁」。
 *
 * 因此移除時機只有一個：**確定要停在這一頁了**。
 * 還要導頁（window.location.href / liff.login）的情況一律不要移除 —— 讓 splash
 * 撐到下一個 document 接手，接縫才看不出來。
 */

const SPLASH_ID = "boot-splash";
/** 與 index.html 的 transition 時間一致；淡出播完才真的從 DOM 拿掉。 */
const FADE_MS = 300;

let removed = false;
let redirecting = false;

/**
 * 宣告「這一頁馬上要導走了」（window.location.href / liff.login）。
 * 之後任何 hideBootSplash() 都會被忽略 —— 導頁是非同步的，中間 React 還會 render，
 * 不擋住的話使用者會瞄到即將被丟棄的那一頁。
 */
export const markBootRedirecting = () => {
  redirecting = true;
};

/** 「登入回跳但目的地未定」的等待窗（waitSdkDeliverOrHome 的最長 3 秒）：
 *  這段期間 authReady 已 true、根路徑會渲染 Welcome 頁——2026-09-09 15:22 實錘使用者
 *  看到歡迎頁一閃數秒、誤以為被登出。hold 讓 splash 撐過等待窗，release 時
 *  （送達或逾時導頁後）才收掉，觀感維持「一次連續載入」。 */
let held = false;

export const holdBootSplash = () => {
  held = true;
};

export const releaseBootSplash = () => {
  if (!held) return;
  held = false;
  hideBootSplash();
};

export const hideBootSplash = () => {
  if (removed || redirecting || held || typeof document === "undefined") return;
  const el = document.getElementById(SPLASH_ID);
  if (!el) {
    removed = true;
    return;
  }
  removed = true;
  // 延到下一個 frame：authReady 與導頁（navigate）常在同一個 tick 內發生，
  // 立刻拿掉會讓使用者瞄到導頁前那一頁的殘影。
  requestAnimationFrame(() => {
    el.classList.add("is-hidden");
    window.setTimeout(() => el.remove(), FADE_MS);
  });
};
